document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pw-product-card').forEach((card) => {
    const image = card.querySelector('.pw-card-variant-image');
    const links = card.querySelectorAll('[data-pw-card-link]');
    card.querySelectorAll('[data-pw-card-variant]').forEach((choice) => choice.addEventListener('click', () => {
      if (image && choice.dataset.image) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = choice.dataset.image;
      }
      if (choice.dataset.url) links.forEach((link) => { link.href = choice.dataset.url; });
      card.querySelectorAll('[data-pw-card-variant]').forEach((item) => item.classList.toggle('is-selected', item === choice));
    }));
  });

  document.querySelectorAll('[data-pw-product]').forEach((root) => {
    const dataNode = root.querySelector('[data-pw-variants]');
    if (!dataNode) return;

    let variants = [];
    try { variants = JSON.parse(dataNode.textContent); } catch (error) { return; }

    const hiddenId = root.querySelector('[data-pw-variant-id]');
    const addButtons = root.querySelectorAll('[data-pw-add], .pw-product-v161__quick-add, .pw-product-v161__final-buy button');
    const prices = root.querySelectorAll('[data-pw-price]');
    const mainImage = root.querySelector('[data-pw-main-image]');
    const preservePackageImage = root.classList.contains('pw-product-v161--package');
    const message = root.querySelector('[data-pw-variant-message]');
    const stock = root.querySelector('[data-pw-stock]');

    const setMainImage = (source) => {
      if (!mainImage || !source) return;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = source;
    };

    const money = (cents) => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    const selectedValues = () => Array.from(root.querySelectorAll('[data-pw-option]')).map((group) => {
      const checked = group.querySelector('input:checked');
      return checked ? checked.value : '';
    });

    const update = (preferredInput) => {
      const values = selectedValues();
      const variant = variants.find((item) => item.options.every((option, index) => String(option) === String(values[index])));
      root.querySelectorAll('[data-pw-option]').forEach((group) => {
        group.querySelectorAll('.pw-product-v161__choice').forEach((choice) => choice.classList.toggle('is-selected', choice.querySelector('input').checked));
        const label = group.querySelector('[data-pw-option-label]');
        const checked = group.querySelector('input:checked');
        if (label && checked) label.textContent = checked.value;
      });

      if (!variant) {
        addButtons.forEach((button) => { button.disabled = true; });
        if (message) message.textContent = 'Deze combinatie is niet beschikbaar.';
        if (stock) { stock.classList.add('is-unavailable'); stock.querySelector('b').textContent = 'Niet beschikbaar'; stock.querySelector('small').textContent = 'Kies een andere combinatie'; }
        return;
      }

      if (hiddenId) hiddenId.value = variant.id;
      prices.forEach((node) => { node.textContent = money(variant.price); });
      addButtons.forEach((button) => {
        button.disabled = !variant.available;
        if (button.hasAttribute('data-pw-add')) button.textContent = variant.available ? 'Voeg toe aan winkelwagen' : 'Uitverkocht';
      });
      if (message) message.textContent = variant.available ? '' : 'Deze uitvoering is momenteel uitverkocht.';
      if (stock) {
        stock.classList.toggle('is-unavailable', !variant.available);
        stock.querySelector('b').textContent = variant.available ? 'Op voorraad' : 'Uitverkocht';
        stock.querySelector('small').textContent = variant.available ? 'Veilig besteld en snel verzonden' : 'Kies een andere uitvoering';
      }

      const mappedImageSource = preferredInput && preferredInput.dataset.choiceImage;
      const imageSource = mappedImageSource || (variant.featured_image && (variant.featured_image.src || variant.featured_image.url));
      if (!preservePackageImage) setMainImage(imageSource);
      if (window.history && window.history.replaceState) window.history.replaceState({}, '', `${window.location.pathname}?variant=${variant.id}`);
    };

    root.querySelectorAll('[data-pw-option] input').forEach((input) => input.addEventListener('change', () => update(input)));
    root.querySelectorAll('[data-pw-property-choice] input').forEach((input) => input.addEventListener('change', () => {
      const group = input.closest('[data-pw-property-choice]');
      const label = group && group.querySelector('[data-pw-property-label]');
      if (label) label.textContent = input.value;
    }));
    const galleryThumbs = Array.from(root.querySelectorAll('[data-pw-thumb]'));
    const activateGalleryImage = (index) => {
      if (!galleryThumbs.length) return;
      const normalizedIndex = (index + galleryThumbs.length) % galleryThumbs.length;
      const thumb = galleryThumbs[normalizedIndex];
      setMainImage(thumb.dataset.image);
      galleryThumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };
    galleryThumbs.forEach((thumb, index) => thumb.addEventListener('click', () => activateGalleryImage(index)));

    const galleryStage = root.querySelector('[data-pw-gallery-stage]');
    if (galleryStage && galleryThumbs.length > 1) {
      let touchStartX = 0;
      let touchStartY = 0;
      galleryStage.addEventListener('touchstart', (event) => {
        const touch = event.changedTouches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      }, { passive: true });
      galleryStage.addEventListener('touchend', (event) => {
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        if (Math.abs(deltaX) < 42 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        const currentIndex = Math.max(0, galleryThumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
        activateGalleryImage(currentIndex + (deltaX < 0 ? 1 : -1));
      }, { passive: true });
    }
    const osmosisAddon = root.querySelector('[data-pw-osmosis-addon]');
    const productForm = hiddenId && hiddenId.closest('form');
    if (osmosisAddon && productForm) productForm.addEventListener('submit', async (event) => {
      if (!osmosisAddon.checked || productForm.dataset.pwBundleAdding === 'true') return;
      event.preventDefault();
      const selectedVariantId = Number(hiddenId.value);
      const addonVariantId = Number(osmosisAddon.dataset.addonVariantId);
      const quantityInput = productForm.querySelector('[name="quantity"]');
      const quantity = Math.max(1, Number(quantityInput && quantityInput.value) || 1);
      if (!selectedVariantId || !addonVariantId) return;
      productForm.dataset.pwBundleAdding = 'true';
      addButtons.forEach((button) => { button.disabled = true; });
      try {
        const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: selectedVariantId, quantity }, { id: addonVariantId, quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Toevoegen mislukt');
        window.location.assign(`${shopRoot}cart`);
      } catch (error) {
        productForm.dataset.pwBundleAdding = 'false';
        addButtons.forEach((button) => { button.disabled = false; });
        if (message) message.textContent = 'Het samen toevoegen is niet gelukt. Probeer het opnieuw.';
      }
    });
    update();
  });

  document.querySelectorAll('[data-hero-slider][data-package-url]').forEach((slider) => {
    const packageButton = slider.querySelector('.pw-slide--2 .pw-actions .pw-btn--green');
    if (packageButton && slider.dataset.packageUrl) packageButton.href = slider.dataset.packageUrl;
  });
});
